
import { Breadcrumb } from "antd";
import { useState, useContext } from "react";
import PreviewModal from "../previewModal/PreviewModal";
import {
  ButtonGroup,
  ContainerFooterBtn,
  ModalButton,
  TopBarContainer,
  Wrapper,
} from "./style";
import { ChannelContext } from "../../../context/channel";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { t } from "i18next";
import Button from "../../shared/button/Button";
import colors from "../../../theme/colors";
import EyeIcon from "../../shared/Icons/EyeIcon";
import BaseModal from "../../shared/BaseModal";
import { handleSaveDashboardCustomization } from "../../../utils/saveDashboardCustomization";

interface ITopBar {
  setIsShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  pageTitle: string;
  selectedSettingsPage: string;
}

export default function TopBar({
  setIsShowModal,
  pageTitle,
  selectedSettingsPage,
}: ITopBar) {
  const dashboardContext = useContext(ChannelContext);

  const [toggleModalPreview, setToggleModalPreview] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const breakpoints = useBreakpoint();

  return (
    <TopBarContainer>
      <Wrapper>
        <Breadcrumb
          separator=">"
          style={{ display: "flex", alignItems: "center" }}
        >
          {breakpoints.md ? (
            <>
              <Breadcrumb.Item>{t('manage')}</Breadcrumb.Item>
              <Breadcrumb.Item href={"#"}>White Label</Breadcrumb.Item>
            </>
          ) : (
            <Breadcrumb.Item href={"#"}>...</Breadcrumb.Item>
          )}
          <Breadcrumb.Item>{pageTitle}</Breadcrumb.Item>
        </Breadcrumb>

        <ButtonGroup>
          <Button
            enable
            variant="outlined"
            colorBackground="border"
            colorHover="white"
            backgroundHover="border"
            customColor={colors.border}
            onClick={() => {
              setToggleModalPreview(!toggleModalPreview);
            }}
            className="eye"
            style={{
              borderRadius: !breakpoints.md ? "50%" : "40px",
              width: !breakpoints.md ? "40px" : "90px",
              height: !breakpoints.md ? "40px" : "46px",
              padding: !breakpoints.md ? 0 : "10px 28px",
              border: `1px solid ${colors.border}`,
            }}
          >
            {!breakpoints.md ? <EyeIcon size="18" /> : "Preview"}
          </Button>
          <Button
            onClick={() => setIsShowModal(true)}
            enable
            style={{
              borderRadius: "40px",
              width: "100px",
              height: !breakpoints.md ? "40px" : "46px",
              border: "none",
            }}
          >
            {t('publish')}
          </Button>
        </ButtonGroup>
      </Wrapper>
      <BaseModal
        toggleModal={toggleModalPreview}
        setToggleModal={setToggleModalPreview}
        title={"Preview"}
        onCancel={() => setToggleModalPreview(false)}
        footer={[
          <ContainerFooterBtn>
            <ModalButton onClick={() => setToggleModalPreview(false)}>
              {t('cancel')}
            </ModalButton>
            <ModalButton
              className="red-btn"
              onClick={async () => {
                await handleSaveDashboardCustomization(dashboardContext);
                setToggleModalPreview(false);
                setShowPreviewModal(true);
              }}
            >
              {t('dashboard.modal.preview.sabeAndPreview')}
            </ModalButton>
          </ContainerFooterBtn>,
        ]}
      >
        <span>
        {t('dashboard.modal.preview.text')}
        </span>
      </BaseModal>
      {showPreviewModal && (
        <PreviewModal
          setShowPreviewModal={setShowPreviewModal}
          selectedSettingsPage={selectedSettingsPage}
        />
      )}
    </TopBarContainer>
  );
}
